<template>
    <div class="container">
        <div class="row row-eq-height news-list" v-if="articles.length > 0" v-bind:class="{'pending': pagination.pending}">
            <div class="col-12 col-sm-6 col-lg-3" v-for="article in articles" :key="article.id">
              <div class="news-list__item">
                <router-link :to="{name: 'News', params: { id: article.id }}" class="news-list__item-link">
                    <img v-auth-image="'/photos/'+ article.thumbnail_image_id + '?thumbnail=300'" alt="">
                    <p>{{ article.created_at | formatDate('DD.MM.YYYY') }}</p>
                    <h4>{{ article.title }}</h4>
                </router-link>
              </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <pagination class="pagination-wraper" v-model="pagination.current_page" :page="pagination.current_page" :per-page="parseInt(pagination.per_page)" :records="pagination.total" @paginate="onChangePaginate" v-if="pagination && pagination.last_page > 1"></pagination>
            </div>
        </div>
        <div class="row profile profile--mb" v-if="articles.length == 0">
            <div class="col col-12">
                <p>brak aktualności</p>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'NewsListComponent',
  data () {
    return {
        articles: [],
        pagination: {}
    }
  },
  beforeRouteEnter(to, from, next) {
    Vue.axios({
      method: 'get',
      url: '/articles'
    })
    .then(response => {
      next(vm => {
        vm.articles = response.data.data.articles
        vm.pagination = response.data.pagination
      })
    })
    .catch(error => next(false))
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  mounted: function() {
    if( !this.user || this.user.id != 1 ) {
        this.$gtag.pageview({
            page_path: '/aktualnosci',
        })
    }
  },
  methods: {
    /**
     * On change paginate event.
     *
     * @param  {int} page
     * @return void
     */
    onChangePaginate(page) {
        let vm = this

        vm.pagination.pending = true

        Vue.axios({
            method: 'get',
            url: '/articles',
            params: {
                page: page
            }
        })
        .then(response => {
            vm.articles = response.data.data.articles
            vm.pagination = response.data.pagination
            vm.pagination.pending = false
        })
        .catch(error => vm.pagination.pending = false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/news/NewsListComponent.vue